import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * This component renders llms.txt content for AI crawlers
 * llms.txt is a standard for providing context to LLMs about your website
 */
const LlmsTxt = () => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLlmsTxt = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/llms.txt`, {
          headers: {
            'Accept': 'text/plain'
          }
        });
        setContent(response.data);
      } catch (err) {
        console.error("Error fetching llms.txt:", err);
        // Fallback content
        setContent(`# Kokan Homestays
> Discover authentic homestay experiences in the Konkan region of Maharashtra, India.

## About
Kokan Homestays is a platform connecting travelers with local homestay accommodations in the scenic Konkan coastal region. We feature verified homestays in Dapoli, Ratnagiri, Ganpatipule, Tarkarli, and other beautiful destinations.

## What We Offer
- Curated homestay listings with verified hosts
- Authentic local experiences
- Detailed information about nearby places of interest
- Travel guides and blog content about Konkan

## Contact
Website: https://kokanhomestays.in
Email: info@kokanhomestays.in`);
      } finally {
        setLoading(false);
      }
    };

    fetchLlmsTxt();
  }, []);

  useEffect(() => {
    if (!loading && content) {
      // Style for plain text display
      document.body.style.margin = '0';
      document.body.style.padding = '8px';
      document.body.style.fontFamily = 'monospace';
      document.body.style.fontSize = '14px';
      document.body.style.backgroundColor = 'white';
      document.body.style.color = 'black';
      
      // Remove stylesheets
      const styleSheets = document.querySelectorAll('link[rel="stylesheet"]');
      styleSheets.forEach(sheet => sheet.remove());
      
      document.title = 'llms.txt';
    }
  }, [loading, content]);

  if (loading) {
    return null;
  }

  return (
    <pre style={{
      margin: 0,
      padding: 0,
      fontFamily: 'monospace',
      fontSize: '14px',
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word'
    }}>
      {content}
    </pre>
  );
};

export default LlmsTxt;
